import { actionTypes } from "../contants/actionTypes";


const initialState = {
    loading: false,
    error: false,
};

export const groupReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.groupInsertStart:
        case actionTypes.groupUpdateStart:
            return {
                ...state,
                loading: true,
                error: false
            };
        case actionTypes.groupErrorInsert:
        case actionTypes.groupErrorUpdate:
            return { 
                ...state, 
                loading: false,
                error: true 
            };
        case actionTypes.groupFinishInsert:
        case actionTypes.groupFinishUpdate:
            return { 
                ...state, 
                loading: false 
            };
        default:
            return state;
    }
};